module.exports = __webpack_public_path__ + "img/胡勇.7b4c432f.jpg";